var _defs, _rect, _use, _circle, _circle2, _circle3, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrafficLightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "134px",
    viewBox: "0 0 66 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "44.0687522%",
    fx: "50%",
    fy: "44.0687522%",
    r: "198.40551%",
    gradientTransform: "translate(0.500000,0.440688),scale(1.000000,0.447154),rotate(90.000000),translate(-0.500000,-0.440688)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 4.375,
    y: 4.56080193,
    width: 55,
    height: 123,
    rx: 27.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.7%",
    y: "-1.2%",
    width: "105.5%",
    height: "102.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.752689085   0 0 0 0 0.752689085   0 0 0 0 0.752689085  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Lifestyle-Assessment-Intro",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-607.000000, -1552.000000)",
    id: "Rectangle-Copy-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(640.000000, 1618.564798) rotate(-90.000000) translate(-640.000000, -1618.564798) translate(573.500000, 1586.064798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-2",
    transform: "translate(66.416667, 32.416667) rotate(-270.000000) translate(-66.416667, -32.416667) translate(34.416667, -33.583333)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#EBEBEB",
    fill: "url(#linearGradient-1)",
    x: 0.375,
    y: 0.560801926,
    width: 63,
    height: 131,
    rx: 31.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-2)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-3"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5CE0B0",
    cx: 31.8857053,
    cy: 99.9206624,
    r: 13.5571413
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#FF520B",
    cx: 31.8857053,
    cy: 65.7613512,
    r: 13.5571413
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#DF0035",
    cx: 31.8857053,
    cy: 31.6020399,
    r: 13.5571413
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9494665,83.5519325 C40.0979652,83.5519325 46.7036286,90.1575959 46.7036286,98.3060946 C46.7036286,99.1130076 46.6388525,99.9047914 46.5142167,100.67653 C45.3804521,93.654325 39.2911832,88.2919587 31.9494665,88.2919587 C24.6077499,88.2919587 18.518481,93.654325 17.3846557,100.676062 C17.2600806,99.9047914 17.1953045,99.1130076 17.1953045,98.3060946 C17.1953045,90.1575959 23.8009678,83.5519325 31.9494665,83.5519325 Z",
    id: "Combined-Shape-Copy-3",
    fill: "#575756"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9494665,48.637115 C40.0979652,48.637115 46.7036286,55.2427783 46.7036286,63.391277 C46.7036286,64.19819 46.6388525,64.9899738 46.5142167,65.761712 C45.3804521,58.7395074 39.2911832,53.3771411 31.9494665,53.3771411 C24.6077499,53.3771411 18.518481,58.7395074 17.3846557,65.761244 C17.2600806,64.9899738 17.1953045,64.19819 17.1953045,63.391277 C17.1953045,55.2427783 23.8009678,48.637115 31.9494665,48.637115 Z",
    id: "Combined-Shape-Copy-4",
    fill: "#575756"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9494665,14.4778037 C40.0979652,14.4778037 46.7036286,21.0834671 46.7036286,29.2319658 C46.7036286,30.0388788 46.6388525,30.8306626 46.5142167,31.6024007 C45.3804521,24.5801961 39.2911832,19.2178299 31.9494665,19.2178299 C24.6077499,19.2178299 18.518481,24.5801961 17.3846557,31.6019328 C17.2600806,30.8306626 17.1953045,30.0388788 17.1953045,29.2319658 C17.1953045,21.0834671 23.8009678,14.4778037 31.9494665,14.4778037 Z",
    id: "Combined-Shape-Copy-5",
    fill: "#575756"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLightIcon);
export default __webpack_public_path__ + "static/media/traffic-light-icon.ff3ca3cb75ed94e1bef861af7d2a3f5e.svg";
export { ForwardRef as ReactComponent };